import { defineComponent as _defineComponent } from 'vue'
import {useToast} from "vue-toastification";
import {ref} from "vue";
import {useI18n} from "vue-i18n";
// import {useUserStore} from "@/store/user.store";
// import {useConfigurationStore} from "@/store/configuration.store";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopMenu',
  setup(__props, { expose: __expose }) {
  __expose();


const dropdown = ref(false);
const toggleDropdown = () => {
  dropdown.value = !dropdown.value;
};

const closeDropdown = () => {
    dropdown.value = false;
};
const i18n = useI18n();
const toast = useToast();
const app_version = process.env.VUE_APP_VERSION;
const compilation_timestamp = process.env.VUE_APP_COMPILATION_TIMESTAMP;
// const isFaucetAvailable= computed(() => {
//   return useConfigurationStore().config.faucetAvailable;
// });
// function topup() {
//     console.log('topup');
//     useUserStore().topUpAccount(
//         () => {
//             toast.success(i18n.t('TOAST.SUCCESS.TOP_UP'));
//         },
//         () => {
//             toast.error(i18n.t('TOAST.ERROR.TOP_UP'));
//         });
// }



const __returned__ = { dropdown, toggleDropdown, closeDropdown, i18n, toast, app_version, compilation_timestamp }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})